import { createDialogContextBundle } from "src/components/Dialog";
import { CloseTransferWarningDialogProps } from "./types";

export const {
  DialogContext: CloseTransferWarningDialogContext,
  useDialogContext: useCloseTransferWarningDialogContext,
} = createDialogContextBundle<CloseTransferWarningDialogProps>();
